import React, { } from 'react';

import 'css/StepHistory.css';



const Step = ({ name, index, currentStepIndex, onStepClick }) => {

    let smallText = index + 1;
    let className = "coloured";
    let onClick;

    // if they're further, only write the name
    if (index > currentStepIndex) {
        className = "";
    }

    if (index === currentStepIndex) {
        className += " selected";
        smallText = name;
    }

    if (index < currentStepIndex) {
        onClick = () => onStepClick(index);
        className += " cursor-pointer";
    }

    return (
        <li className={className} onClick={onClick}>
            <span className={"show-for-medium"}>{name}</span>
            <span className={"show-for-small-only"}>{smallText}</span>
        </li>
    );
};

export const StepHistory = ({ StepList, StepIndex, onStepClick }) => (
    <div className="StepHistory">
        <ul>
            {
                StepList.map((value, index) =>
                    <Step key={index} name={value.name} index={index} currentStepIndex={StepIndex} onStepClick={onStepClick} />
                )
            }
        </ul>
    </div>
);




// WEBPACK FOOTER //
// ./src/components/Steps.js